import React, { useState, useEffect } from 'react';
import { BUTTON_TYPE } from '../../../../ui-components/PlayButton/PlayButton';
import {
    Section,
    Header,
    SectionExpandArrow,
    SectionHeaderLink,
    ShowMoreButton,
    ShowMoreIcon,
} from './AssociatedContent.styles';
import Link from 'next/link';
import { useRouter } from 'next/router';

const AssociatedContentSection = ({ name, id, children, defaultExpanded, max }) => {
    const childrenArray = React.Children.toArray(children);

    const [expanded, setExpanded] = useState(defaultExpanded);
    const [showAll, setShowAll] = useState(childrenArray.length <= max);
    const router = useRouter();

    useEffect(() => {
        setExpanded(defaultExpanded);
    }, [defaultExpanded]);

    const { tab, ...queryWithoutTab } = router.query; // eslint-disable-line no-unused-vars
    const queryParams = expanded ? queryWithoutTab : { ...router.query, tab: id };

    return (
        <Section>
            <Header as="h2" expanded={expanded}>
                <Link
                    href={{
                        pathname: router.pathname,
                        query: { ...queryParams },
                    }}
                    passHref
                    scroll={false}
                >
                    <SectionHeaderLink
                        onMouseUp={(e) => {
                            e.currentTarget.blur();
                        }}
                        onClick={() => setExpanded(!expanded)}
                        aria-expanded={expanded}
                        data-rt="associated-content-accordion-header"
                    >
                        <SectionExpandArrow expanded={expanded} />
                        {name}
                    </SectionHeaderLink>
                </Link>
            </Header>
            {expanded &&
                (showAll ? (
                    <div id={id}>{children}</div>
                ) : (
                    <>
                        {childrenArray.slice(0, max)}
                        <ShowMoreButton
                            buttonType={BUTTON_TYPE.BUTTON}
                            isCentered
                            onClick={(e) => setShowAll(true)}
                            aria-label="Visa fler avsnitt"
                        >
                            <ShowMoreIcon aria-hidden />
                            Visa fler
                        </ShowMoreButton>
                    </>
                ))}
        </Section>
    );
};

export default AssociatedContentSection;
